import React from "react";
import { graphql, useStaticQuery } from "gatsby";
import Form1 from "./form1";
import FormNewsletter from "./form-newsletter";
import Form3 from "./form3";
import Form4 from "./form4";
import Form5 from "./form5";
import Form6 from "./form6";
import Form7 from "./form7";
import FormEcommerce from "./form-ecommerce";
import FormEcommerceWashpass from "./form-ecommerce-washpass";

const Form = ({ data, location }) => {
  const {
    site: { siteMetadata },
    labelManagerLabels,
  } = useStaticQuery(graphql`
    {
      site {
        siteMetadata {
          babelPrefix
          priceLanguage
        }
      }
      labelManagerLabels: labelManagerLabels {
        select
        requiredFields
        formRequest
        formTechnicalSupportRequest
        formHowtoUseAndInstructions
        formProductAccessoriesInformation
        formProductLine
        formModel
        formProductCode
        formPurchaseDate
        dateFormat
        formName
        formLastName
        formEmail
        formAddress
        formCity
        formProvince
        formZipCode
        formPhone
        formMobile
        formComments
        bookletFindImage
        validEmail
        validNumber
        send
        bookletSearchHaier
        yes
        no
        validDate
        valid20Letters
        valid16Numbers
        serialNumberValidation
        serialNumber
        company
        companyCode
        howReadProductCode
        builtIn
        freestanding
        lookingProductInfo
        contactPressOffice
        communicationAdvOffice
        supportAppliance
        typeOfInstallation
        checkAndCareType
        checkAndCareAssistance
        checkAndCareAssistanceText
        formChooseProduct
        formShopOnline
        formStateOrder
        formShipping
        formReturnAndRefund
        formCreateAccount
        formOrderNumber
        formSupportWashpass
        serviceNotAvailable
      }
    }
  `);

  return (
    <React.Fragment>
      {
        {
          "Contact Us": <Form1 data={data} labelManagerLabels={labelManagerLabels} />,
          "Newsletter": (
            <FormNewsletter
              data={data}
              labelManagerLabels={labelManagerLabels}
              location={location}
            />
          ),
          "Assistance request": <Form3 data={data} labelManagerLabels={labelManagerLabels} />,
          "Booklet request": (
            <Form4 data={data} labelManagerLabels={labelManagerLabels} location={location} />
          ),
          "Booklet download": (
            <Form5 data={data} labelManagerLabels={labelManagerLabels} location={location} />
          ),
          "Compliance": <Form6 data={data} labelManagerLabels={labelManagerLabels} />,
          "Check and Care Program": (
            <Form7
              data={data}
              labelManagerLabels={labelManagerLabels}
              siteMetadata={siteMetadata}
            />
          ),
          "Ecommerce Form": (
            <FormEcommerce
              data={data}
              labelManagerLabels={labelManagerLabels}
              siteMetadata={siteMetadata}
            />
          ),
          "Ecommerce product choice": (
            <FormEcommerce
              data={data}
              labelManagerLabels={labelManagerLabels}
              siteMetadata={siteMetadata}
            />
          ),
          "Ecommerce purchase support": (
            <FormEcommerce
              data={data}
              labelManagerLabels={labelManagerLabels}
              siteMetadata={siteMetadata}
            />
          ),
          "Ecommerce order status": (
            <FormEcommerce
              data={data}
              labelManagerLabels={labelManagerLabels}
              siteMetadata={siteMetadata}
            />
          ),
          "Ecommerce info delivery": (
            <FormEcommerce
              data={data}
              labelManagerLabels={labelManagerLabels}
              siteMetadata={siteMetadata}
            />
          ),
          "Ecommerce return refund": (
            <FormEcommerce
              data={data}
              labelManagerLabels={labelManagerLabels}
              siteMetadata={siteMetadata}
            />
          ),
          "Ecommerce account creation": (
            <FormEcommerce
              data={data}
              labelManagerLabels={labelManagerLabels}
              siteMetadata={siteMetadata}
            />
          ),
          "Washpass Ecommerce Form": (
            <FormEcommerceWashpass
              data={data}
              labelManagerLabels={labelManagerLabels}
              siteMetadata={siteMetadata}
            />
          ),
          "Washpass Ecommerce Form Complete": (
            <FormEcommerceWashpass
              data={data}
              labelManagerLabels={labelManagerLabels}
              siteMetadata={siteMetadata}
            />
          ),
        }[data.tipology?.[0]]
      }
    </React.Fragment>
  );
};

export default Form;
export const fragment = graphql`
  fragment FormConfigurationFragment on LiferayFormConfiguration {
    id
    liferayFields {
      siteId
      articleId
    }
    tipology
    lines {
      ... on LiferayLinesMultivalue {
        selectGroups {
          label
          group {
            label
            value
          }
        }
      }
    }
    fields {
      hrefLanguages
    }
    retUrl
    recaptchaActive
    privacyText {
      ... on LiferayFormPrivacyText {
        brand
        websiteSource
        country
        language
        leadSource
        status
        isTestRecord
        campaign
        campaignSource
        privacy1FieldSet {
          privacy1
          privacy1Default
        }
        privacy2FieldSet {
          privacy2
          privacy2Default
        }
        privacy3FieldSet {
          privacy3
          privacy3Default
        }
      }
    }
  }
`;
